import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const orderImporterSelectors = importerSelectors(
  'order.importer',
)

export default orderImporterSelectors
